import React from 'react'
import PropTypes from 'prop-types'

import { Feed, List } from 'semantic-ui-react'

import ChangelogEventItem from 'Components/ChangelogModal/ChangelogEventItem'

import icons from 'Global/icons'

const ChangelogEvent = ({ date, items, title, version }) => (
  <Feed.Event>
    <Feed.Label icon={icons['changelog']} />

    <Feed.Content>
      <Feed.Date>{date}</Feed.Date>

      <Feed.Summary>{title}</Feed.Summary>

      <Feed.Extra>
        <List>
          {items.map(item => (
            <ChangelogEventItem item={item} key={item.description + item.headline} />
          ))}
        </List>
      </Feed.Extra>
    </Feed.Content>

    <Feed.Meta>{`${version}`}</Feed.Meta>
  </Feed.Event>
)

ChangelogEvent.propTypes = {
  date: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      headline: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  title: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
}

export default ChangelogEvent
